import { render, staticRenderFns } from "./CreateDrivingStaff.vue?vue&type=template&id=6e5a1ca4"
import script from "./CreateDrivingStaff.vue?vue&type=script&lang=js"
export * from "./CreateDrivingStaff.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports